import { getAssetUrl } from "@client/lib/assets";
import { getMedia } from "@client/lib/settings";
import { MediaType } from "@client/types";

export const getContentAssetUrl = (url: string, type: MediaType = MediaType.Image) =>
  getAssetUrl(getMedia(url, type), type);
